// extracted by mini-css-extract-plugin
export default {"container":"MapContainer_container__x52Ap"};